import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FolderOpen, Images } from 'lucide-react'

import { STUDIO_BASE } from '@/features/studio/lib/studio-paths'
import { cn } from '@/shared/lib/utils'

const TAB_CLASS =
  'inline-flex shrink-0 items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-medium transition'

const TAB_ACTIVE_CLASS =
  'border-violet-400/45 bg-violet-500/15 text-violet-100 ring-1 ring-inset ring-violet-400/35'

const TAB_IDLE_CLASS =
  'border-zinc-700/90 bg-zinc-900/70 text-zinc-400 hover:border-zinc-600 hover:bg-zinc-900 hover:text-zinc-200'

type CreativeLibraryTab = 'workspaces' | 'assets'

export function CreativeLibraryTabs({ active }: { active: CreativeLibraryTab }) {
  const { t } = useTranslation()

  return (
    <nav aria-label={t('creative.library.nav')} className="mb-4 flex gap-2">
      <NavLink
        to={`${STUDIO_BASE}/creative`}
        end
        className={cn(TAB_CLASS, active === 'workspaces' ? TAB_ACTIVE_CLASS : TAB_IDLE_CLASS)}
        aria-current={active === 'workspaces' ? 'page' : undefined}
      >
        <FolderOpen className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden />
        {t('creative.library.workspaces')}
      </NavLink>
      <NavLink
        to={`${STUDIO_BASE}/creative/assets`}
        className={cn(TAB_CLASS, active === 'assets' ? TAB_ACTIVE_CLASS : TAB_IDLE_CLASS)}
        aria-current={active === 'assets' ? 'page' : undefined}
      >
        <Images className="h-3.5 w-3.5 shrink-0 opacity-80" aria-hidden />
        {t('creative.library.assets')}
      </NavLink>
    </nav>
  )
}
